// extracted by mini-css-extract-plugin
module.exports = {"login-bg":"login-bg--1uBGw","loginBg":"login-bg--1uBGw","login-bg-particles":"login-bg-particles--2Bs64","loginBgParticles":"login-bg-particles--2Bs64"};